import { SignUp } from "@clerk/nextjs";
import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";

export default function SignUpPage() {
  return (
    <div className="min-h-screen bg-white flex flex-col">
      <Header />
      <main className="flex-1 flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
        <div className="w-full max-w-md">
          <div className="bg-white p-8 rounded-lg shadow-sm border border-gray-200">
            <SignUp
              routing="path"
              path="/sign-up"
              forceRedirectUrl="/dashboard"
            />
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}
